export default __webpack_public_path__ + "static/media/imageNota.738248e9.png";